import { Injectable, inject } from '@angular/core';
import { ApiClientService } from './api-client.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly apiClientService = inject(ApiClientService);
  private readonly authService = inject(AuthService);

  public async sendReport(smartphotoID: string, emails: string[], comments: string): Promise<void> {
    if (!emails.length) {
      throw new Error('Emails are mandatory to send reports');
    }

    if (!smartphotoID) {
      throw new Error('Smartphoto ID is mandatory to send reports');
    }

    const response = await this.apiClientService.getMotorSmartphotosApiClient().smartphotoId.reportPost(
      smartphotoID,
      {
        emails: emails,
        comments: comments
      },
      {
        headers: {
          access_token: this.authService.getAccessToken()
        }
      }
    );
    response.status;
  }
}
